export default "__VITE_ASSET__996719f4__"